import { useState } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import SignupForm from './SignupForm';
import * as duckActions from './duck';
import styles from './index.module.less';

import { IntlLink, IntlMessage, Modal } from '$HVUI';

export const Signup = props => {
    const {
        loggedIn,
        signupValues,
        company,
        _modalVisible = false,
        intl
    } = props;

    // false for closed, string for type when opened
    const [modalVisible, setModalVisibleRaw] = useState(_modalVisible);
    const [modalID, setModalID] = useState(null);

    const setModalVisible = newState => {
        setModalVisibleRaw(newState);
    };

    const twilioShortcode = window.twilio_shortcode || 'XXXXXX';
    if (loggedIn) {
        return <Redirect to="consents" push />;
    }
    const isTelehealth = company?.title == 'Healthvana Telehealth';

    // Do the value clean in the component so the redux action
    // can remain as flexible as possible.
    // Or do we care if they are tightly coupled?
    // Depends on if we think we'll have shared signup actions in future.
    const handleSubmit = async values => {
        if (values.phone_number_type !== 'mobile') {
            values.is_sms = false;
        }

        // If they unchecked the checkbox after typing something,
        // don't submit it.
        if (!values.has_preferred_name) {
            delete values.preferred_name;
        }
        // Don't need to pass checkbox field ever.
        delete values.has_preferred_name;

        try {
            return await props.signUp(values);
        } catch (e) {
            const hasEmailExistsError = e?.errors?.email?.some(str =>
                str.includes('already exists')
            );
            const hasSimilarAccountError = e?.errors?.phone_number?.some(str =>
                str.includes('Similar Healthvana account exists')
            );
            // Specifically internationalize this error,
            // b/c the BE doesn't have full intl
            if (hasEmailExistsError) {
                setModalVisible(true);
                setModalID('account-creation.account-already-exists-modal');
                e.errors.email[0] = intl.formatMessage({
                    id: 'account-creation.account-already-exists',
                    defaultMessage:
                        'Healthvana account already exists. Instructions to reset your password have been emailed to you.'
                });
            }
            // Specifically internationalize this error,
            // b/c the BE doesn't have full intl
            if (hasSimilarAccountError) {
                setModalVisible(true);
                setModalID('account-creation.similar-account-exists');
                e.errors.phone_number[0] = intl.formatMessage({
                    id: 'account-creation.similar-account-exists',
                    defaultMessage:
                        'A similar Healthvana account already exists. The Front Desk staff can help you get access to your account.'
                });
            }
            // Since we caught to modify the error message, we have to re-throw now
            throw e;
        }
    };

    return (
        <>
            <h1 style={{ marginTop: 'var(--32px)', marginBottom: '0' }}>
                <IntlMessage
                    id="account-creation.create-your-healthvana-account"
                    defaultMessage="Create your Healthvana account"
                />
            </h1>
            <div className={styles['previous-account-message']}>
                <p>
                    {isTelehealth ? (
                        <IntlMessage
                            id="account-creation.duplicate-account-message-telehealth"
                            defaultMessage="If you previously had a Healthvana account, please do not create a new account."
                        />
                    ) : (
                        <IntlMessage
                            id="account-creation.duplicate-account-message"
                        defaultMessage="If you previously had a Healthvana account, please do not create a new account. The front desk staff can assist you with getting access to your previous account."
                        />
                    )}
                </p>
            </div>
            <SignupForm
                _values={signupValues}
                onSubmit={handleSubmit}
                initialValues={{ is_sms: false, phone_number_type: 'mobile' }}
                company={company}
            />
            <Modal
                isOpen={modalVisible}
                confirmButtonText="OK"
                confirmButtonColor="ocean-dk"
                cancelText={null}
                headerText="Existing Healthvana Account"
                id="existing-account-modal"
                showCloseButton={true}
                hideOpenButton={true}
            >
                <div>
                    <p style={{ marginBottom: '2rem' }}>
                        <IntlMessage
                            id={
                                modalID
                                    ? modalID
                                    : 'account-creation.account-creation'
                            }
                            defaultMessage="It looks like you previously had a Healthvana account,
                            please do not create a new account. Instructions have
                            been sent to your email address. If you don't have
                            access to that email inbox, the front desk staff can
                            assist you with getting access to your previous account."
                            values={{ company: company.title }}
                        />
                    </p>
                </div>
            </Modal>
        </>
    );
};

export const mapStateToProps = (state, ownProps) => {
    const signupValues = state.form.SignupForm && state.form.SignupForm.values;
    return Object.assign(
        {},
        {
            signupValues,
            initialValues: state.initialValues,
            loggedIn: state.introduction.loggedIn,
            company: state.introduction.company,
            isKiosk: state.introduction.isKiosk
        },
        ownProps
    );
};

export default connect(mapStateToProps, duckActions)(injectIntl(Signup));
